import { Component, Input, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { MediaChange, ObservableMedia } from "@angular/flex-layout";

import { TranslateService } from "../../common/translate/translate.service";
import { NavigationService } from "../../common/navigation/navigation.service";

@Component({
	selector: "sdp-wizard-navigation-top",
	templateUrl: "./wizard-navigation-top.component.html",
})
export class WizardNavigationTopComponent implements OnDestroy {
	@Input()
	public selectedPage = "";
	public pages: any[] = [];
	public watcher: Subscription;
	public activeMediaQuery = "";
	public showToolTip = false;

	constructor(
		private media: ObservableMedia,
		private translateService: TranslateService,
		private navigationService: NavigationService
	) {
		this.pages.push({ page: "wizard/home", title: "home.browser.title", icon: getWizardTopIcon("play_circle_outline") });
		this.pages.push({ page: "wizard/applications", title: "applications.header.title", icon: getWizardTopIcon("lock_open") });
		this.pages.push({ page: "wizard/users", title: "users.header.title", icon: getWizardTopIcon("people") });
		this.pages.push({ page: "wizard/policies", title: "assignApplications.header.title", icon: getWizardTopIcon("assignment_turned_in") });
		this.pages.push({ page: "wizard/summary", title: "summary.header.title", icon: getWizardTopIcon("playlist_add_check") });
		this.pages.push({ page: "wizard/access", title: "access.wizard.title", icon: getWizardTopIcon("cloud_download") });

		this.watcher = this.media.subscribe((change: MediaChange) => {
			this.showStepperToolTip(change.mqAlias);
		});
	}

	public ngOnDestroy() {
		this.watcher.unsubscribe();
	}

	public showStepperToolTip(alias: string) {
		if (alias === "xs" || alias === "sm") {
			this.showToolTip = true;
		} else {
			this.showToolTip = false;
		}
	}

	public getStepperToolTip(value: string) {
		return this.translateService.translate(value);
	}

	public goTo(loc: string) {
		this.navigationService.navigate([`/${loc}`]);
	}
}

function getWizardTopIcon(name: string) {
	return { type: "material", name: name, cssClass: "sdp-breadcrumb-circle-icon" };
}

